import React from "react";
import { node } from "prop-types";
import { Col } from "../Grid";
import { classes } from "../utils/classes";
import { useHeader } from "./context";

const HeaderCollapse = ({ children }) => {
	const { isOpen } = useHeader();
	return (
		<Col lg="auto" className={classes("navbar__collapse", isOpen && "show")} id="navbar">
			{children}
		</Col>
	);
};

HeaderCollapse.propTypes = {
	children: node,
};

export default HeaderCollapse;
